import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";
import dataHandler from "@Utils/dataHandler";
// Components
import IkTable from "@Components/IkTable";
import Screen from "@Components/Screen";
// ModalS
import ConfirmModal from "@Modals/ConfirmModal";
import ChatBotCrud from "./Modals/ChatBotCrud";

// Styles
import styles from "./styles.module.css";

const ChatsBots = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState({});
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openBotsCrud, setOpenBotsCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState("");

	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const botsPromise = dataHandler({ dispatch, url: "bots", params: defaultParams });

			const [botsResponse] = await Promise.all([botsPromise]);
			setfilteredCount(botsResponse.count);
			setFilteredItems(botsResponse.items);
		})();
	}, []);

	// modal handlers
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenBotsCrud(true);
	};

	// Table handlers
	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, item);
				break;
			default:
				break;
		}
	};

	// Table handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "bots", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenBotsCrud(true);
				break;
			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `bots/${tableValue.id}` }));
				break;
			default:
				break;
		}
		const botsResponse = await dataHandler({ dispatch, url: "bots", params: defaultParams });
		setfilteredCount(botsResponse.count);
		setFilteredItems(botsResponse.items);
	};

	const handleAddSuccess = async (created) => {
		await handlerData(defaultParams);

		setTableValue(created);
		setModalOption("Edit");
	};

	const setRowStyle = (item) => {
		if (!item.isActive) {
			return { backgroundColor: "rgba(255, 0, 0, 0.24)" };
		}
		return null;
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="ChatBots">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",

									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],

									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Activo",
									key: "isActive",
									format: "boolean",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Nombre",
									key: "name",
									format: "string",
									headerPosition: "left",
									width: 1,
								},
								{
									label: "Descripción",
									key: "note",
									format: "longText",
									stringLength: 40,
									headerPosition: "left",
									width: 15,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem" }}
							print={{ printHeader: { company: companyName, title: "ChatBots", user: userName } }}
							setRowStyle={setRowStyle}
						/>
					</div>
				</div>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar Eliminar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el ChatBot"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}

			{openBotsCrud && (
				<ChatBotCrud
					apiData={apiData}
					tableValue={tableValue}
					onAddSuccess={handleAddSuccess}
					modalCrud={modalOption}
					tagsList={filteredItems}
					onClose={() => {
						return setOpenBotsCrud(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

ChatsBots.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};

export default connect(mapStateToProps)(ChatsBots);
